import {
    game
} from "../../Game";
import { setStrokeStyle } from "../../utils/pixiGraphics";

export const stopCustomBehaviour = () => {
    game.editor.customPrefabMouseDown = null;
    game.editor.customPrefabMouseMove = null;
    game.editor.customDebugDraw = null;
}

export const drawObjectAdding = (prefab, types, allowPrefabs = false, lockMouseCenter = true) => {

    if(!Array.isArray(types)) types = [types];

    const bodyObject = prefab.class.base;
    const sprite = bodyObject.mySprite ? bodyObject.mySprite : bodyObject;

    const editor = game.editor;

    let tarSprite = editor.getPIXIPointFromWorldPoint(editor.mousePosWorld);
    setStrokeStyle(editor.debugGraphics, 1, editor.jointLineColor, 1);

	let highestObject = editor.retrieveHighestSelectedObject(editor.mousePosWorld, editor.mousePosWorld);

    prefab.class.linkObjectTarget = null;

    if(highestObject){
        let objectData = highestObject.mySprite ? highestObject.mySprite.data : highestObject.data;
        let shouldAdd = false;

        types.forEach(type => {
            if(objectData.type === type || (typeof type === 'string' && highestObject.myBody && highestObject.myBody[type]) || (type === game.editor.object_BODY && highestObject.myBody && !highestObject.data.prefabInstanceName)){
                shouldAdd = true;
            }
        })

        if(!allowPrefabs && objectData.prefabInstanceName) shouldAdd = false;

        if(shouldAdd){
            if(lockMouseCenter) tarSprite = highestObject;
            prefab.class.linkObjectTarget = highestObject;
            setStrokeStyle(editor.debugGraphics, 1, "0xFFFF00", 1);
        }
    }

    editor.debugGraphics.moveTo(sprite.x * editor.cameraHolder.scale.x + editor.cameraHolder.x, sprite.y * editor.cameraHolder.scale.y + editor.cameraHolder.y);
    editor.debugGraphics.lineTo(tarSprite.x * editor.cameraHolder.scale.x + editor.cameraHolder.x, tarSprite.y * editor.cameraHolder.scale.y + editor.cameraHolder.y);
    editor.debugGraphics.stroke();
}
